<div class="banner">
    <div class="section"></div>
    <div class="container container-nota-legal section">
        <p>
            <span>{{title}}</span> 
            {{description}}
        </p>
    </div>
    <div class="section"></div>
</div>
